import { type GameState, type SetSwitchProps, type SetCounterProps, type SetVariableProps, type DispatchProps } from 'src/types'
import { newsave } from './defaults'

const setSwitch = (state: GameState, { switchID, boolean }: SetSwitchProps) => ({
  ...state,
  switches: {
    ...state.switches,
    [switchID]: boolean
  }
})

const setCounter = (state: GameState, { counterID, counterEffect }: SetCounterProps) => {
  const key = Object.keys(counterEffect)[0]

  // this checks if the value is sourced directly or from an existing variable

  // @ts-expect-error
  const value = counterEffect[key]

  const count: number = typeof value === 'number' ? value : Number(value) ? Number(value) : state.counters[value] || 0
  return {
    ...state,
    counters: {
      ...state.counters,
      [counterID]: (
        key === '='
          ? count
          : key === '+'
            ? (state.counters[counterID] || 0) + count
            : key === '-' && (state.counters[counterID] || 0) - count < 0 && counterID !== 'karma'
              ? 0
              : key === '-'
                ? (state.counters[counterID] || 0) - count
                : state.counters[counterID]
      )
    }
  }
}

const setVariable = (state: GameState, { variableID, string }: SetVariableProps) => ({
  ...state,
  variables: {
    ...state.variables,
    [variableID]: string
  }
})

const clearLatestLogMessages = (state: GameState) => ({
  ...state,
  logs: [[]]
})

// consider adding props that last from game to game
const newGame = () => newsave

const restartGame = (previousGameState: GameState) =>
  // preserve karma, defeats, victories
  ({
    ...newsave,
    counters: {
      ...newsave.counters,
      player_karma: previousGameState.counters.player_karma || 0,
      player_victories: previousGameState.counters.player_victories || 0,
      player_defeats: previousGameState.counters.player_defeats || 0,
      player_deaths: previousGameState.counters.player_deaths || 0,
      day: previousGameState.counters.day || 0
    },
    variables: {
      ...newsave.variables,
      event_id: 'game_intro',
      enemy_id: ''
    }
  })

export const reducer = (state: GameState, action: DispatchProps) => {
  switch (action.type) {
    case 'NEW_GAME':
      return newGame()
    case 'RESTART_GAME':
      return restartGame(state)
    case 'CLEAR_LATEST_LOG_MESSAGES':
      return clearLatestLogMessages(state)
    case 'SET_COUNTER':
      return setCounter(state, action)
    case 'SET_VARIABLE':
      return setVariable(state, action)
    case 'SET_SWITCH':
      return setSwitch(state, action)
    default:
      return state
  }
}
